// extracted by mini-css-extract-plugin
export default {"paragraphWhite":"paragraph_paragraphWhite__Dkxot","paragraph":"paragraph_paragraph__UkzAF"};